<template>
  <el-row class="row" justify="space-around" align="bottom" >
    <el-col class="icon" :offset="16" :span="8">
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          <i class="fas fa-language"></i>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="en">English</el-dropdown-item>
            <el-dropdown-item command="es">Español</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </el-col>
  </el-row>
</template>
<script>

export default {
  data() {
    return {locales: [
      {language: "en",
      label: "English",
      icon: <i class="fa-light fa-language"></i>},
      {language: "es",
      label: "Spanish",
      icon: <i class="fa-light fa-language"></i>}
    ]};
  },
  computed: {
    routeName() {
      return this.capitalizeFirstLetter(this.$route.name);
    },
    canGoBack() {
      return this.$route.params.from !== undefined;
    }
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    goBack() {
      this.$router.back();
    },
    handleCommand(command) {
      if (command === 'en') {
        this.$i18n.locale = "en";
      }
      if (command === 'es') {
        this.$i18n.locale = "es";
      }
    }
  }
};
</script>
<style scoped>
.row {
  padding-top: 15px;
  padding-left: 5px;
  padding-right: 5px;
}
.box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon {
  display: flex;
  justify-content: center;
  align-items: right;
  padding-top: 20px;
}
.image{
  display: flex;
  height: 50%;
  justify-content: center;
  align-items: center;  
}
i {
  font-size: 30px;
  color: #0F6A88;
}

</style>
